import { render, staticRenderFns } from "./SeriesConfigEditor.vue?vue&type=template&id=4a203132&scoped=true"
import script from "./SeriesConfigEditor.vue?vue&type=script&lang=js"
export * from "./SeriesConfigEditor.vue?vue&type=script&lang=js"
import style0 from "./SeriesConfigEditor.vue?vue&type=style&index=0&id=4a203132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a203132",
  null
  
)

export default component.exports